import { isFloatMatch } from '@impuls-coach/util-is';
import { ValidateOptionsType, ValidationFactoryFunctionReturnType } from 'components/hoc/withValidation';
import i18n from 'helper/i18n';
import { sanitizeFloat } from 'helper/sanitize';
import { VALIDATE_IS_NOT_ALLOWED } from 'helper/validator';

export const i18nKeys = {
	bmiTooLow: 'react.impulsCoach.components.anamnesis.acceptHealthTarget.validation.bmiTooLow',
	inputError: 'react.impulsCoach.components.anamnesis.acceptHealthTarget.validation.inputError',
	invalidFormat: 'react.impulsCoach.components.anamnesis.acceptHealthTarget.validation.invalidFormat',
	targetWeightTooHigh: 'react.impulsCoach.components.anamnesis.acceptHealthTarget.validation.targetWeightTooHigh',
};

export default function weightTargetValidatorFactory(
	value: string,
	options: ValidateOptionsType = {}
): ValidationFactoryFunctionReturnType {
	return new Promise((resolve: Function, reject: Function) => {
		const toVerify: string = value.toString();

		if (toVerify.length === 0 || !options.weight) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(i18nKeys.inputError),
			});
			return;
		}

		if (!isFloatMatch(toVerify)) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(i18nKeys.invalidFormat),
			});
			return;
		}

		if (parseFloat(`${options.weight}`) - parseFloat(toVerify) <= 0) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(i18nKeys.targetWeightTooHigh),
			});
			return;
		}

		if (typeof options.targetBmi === 'number' && toVerify !== '0' && options.targetBmi <= 18.5) {
			reject({
				type: VALIDATE_IS_NOT_ALLOWED,
				message: i18n(i18nKeys.bmiTooLow),
			});
			return;
		}

		resolve();
	});
}

export const sanitize = (value: string): string => {
	return sanitizeFloat(value, 3);
};
